(function () {
  'use strict';

  var config = window.EzsportConfig || {};
  var isLocalPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  var previewSetting = null;

  if (isLocalPreview) {
    var previewParam = new URLSearchParams(window.location.search).get('one_item_test');
    if (previewParam === '1' || previewParam === 'on' || previewParam === 'true') {
      window.sessionStorage.setItem('ezeal_one_item_test', 'true');
    } else if (previewParam === '0' || previewParam === 'off' || previewParam === 'false') {
      window.sessionStorage.removeItem('ezeal_one_item_test');
    }
    previewSetting = window.sessionStorage.getItem('ezeal_one_item_test') === 'true';
  }

  var enabled = config.limitOneItemPerOrder === true || previewSetting === true;
  if (!enabled) return;
  document.body.setAttribute('data-limit-one-item-per-order', 'true');

  var modal = document.getElementById('one-item-replace-modal');
  var panel = document.getElementById('one-item-replace-panel');
  var backdrop = document.getElementById('one-item-replace-backdrop');
  var closeButton = document.getElementById('one-item-replace-close');
  var cancelButton = document.getElementById('one-item-replace-cancel');
  var confirmButton = document.getElementById('one-item-replace-confirm');
  var focusTrap = window.EzsportA11y && panel ? EzsportA11y.createFocusTrap(panel) : null;
  var approvedForms = new WeakSet();
  var pendingDecision = null;
  var modalTrigger = null;
  var bodyOverflowBeforeModal = '';

  function routesRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function cartUrl(path) {
    var root = routesRoot();
    return root + (root.endsWith('/') ? '' : '/') + path.replace(/^\//, '');
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unable to update the cart.');
        }
        return data;
      });
    });
  }

  function getCart() {
    return requestJson(cartUrl('cart.js'));
  }

  function clearCart() {
    return requestJson(cartUrl('cart/clear.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    });
  }

  function refreshCartUi() {
    var refresh = typeof window.refreshCart === 'function' ? window.refreshCart() : Promise.resolve();
    return Promise.resolve(refresh).then(function () {
      lockQuantityControls();
      if (typeof window.openDrawer === 'function') window.openDrawer();
    });
  }

  function lockQuantityControls() {
    document.querySelectorAll('[data-stepper-input]').forEach(function (input) {
      var control = input.closest('div');
      if (control) control.setAttribute('data-cart-quantity-control', '');
      input.readOnly = true;
      input.max = '1';
    });

    document.querySelectorAll('[data-cart-quantity-control] input, [data-product-quantity-control] input').forEach(function (input) {
      input.readOnly = true;
      input.max = '1';
    });
  }

  function closeModal(decision) {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    modal.classList.remove('is-open');
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = bodyOverflowBeforeModal;
    if (focusTrap) focusTrap.deactivate();
    if (!focusTrap && modalTrigger && typeof modalTrigger.focus === 'function') modalTrigger.focus();
    modalTrigger = null;

    var resolve = pendingDecision;
    pendingDecision = null;
    if (resolve) resolve(decision === true);
  }

  function confirmReplacement(trigger) {
    if (!modal) return Promise.resolve(false);
    if (pendingDecision) return Promise.resolve(false);
    modalTrigger = trigger || document.activeElement;
    bodyOverflowBeforeModal = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.classList.remove('hidden');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    if (window.lucide && typeof window.lucide.createIcons === 'function') window.lucide.createIcons();
    if (focusTrap) focusTrap.activate(cancelButton || closeButton);

    return new Promise(function (resolve) {
      pendingDecision = resolve;
    });
  }

  function setModalBusy(isBusy) {
    if (cancelButton) cancelButton.disabled = isBusy;
    if (confirmButton) confirmButton.disabled = isBusy;
    if (closeButton) closeButton.disabled = isBusy;
  }

  function singleMatchingLine(cart, variantId) {
    return cart && cart.items && cart.items.length === 1 &&
      String(cart.items[0].variant_id) === String(variantId);
  }

  function forceFormQuantityToOne(form) {
    var quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = '1';
  }

  function continueFormSubmission(form, submitter) {
    forceFormQuantityToOne(form);
    approvedForms.add(form);
    if (typeof form.requestSubmit === 'function') {
      try {
        if (submitter && submitter.form === form && !submitter.disabled) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
      } catch (error) {
        form.requestSubmit();
      }
    } else {
      form.submit();
    }
  }

  function notifySameItem(form) {
    return refreshCartUi().then(function () {
      document.dispatchEvent(new CustomEvent('cart:add-complete', {
        detail: { form: form, success: true }
      }));
    });
  }

  async function handleFormSubmission(form, submitter) {
    if (!form.checkValidity()) {
      form.reportValidity();
      document.dispatchEvent(new CustomEvent('cart:add-complete', {
        detail: { form: form, success: false }
      }));
      return;
    }

    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;
    if (!variantId) return;

    try {
      var cart = await getCart();
      if (!cart.items || cart.items.length === 0) {
        continueFormSubmission(form, submitter);
        return;
      }

      if (singleMatchingLine(cart, variantId) && cart.item_count === 1) {
        await notifySameItem(form);
        return;
      }

      var shouldReplace = await confirmReplacement(submitter);
      if (!shouldReplace) {
        document.dispatchEvent(new CustomEvent('cart:add-complete', {
          detail: { form: form, success: false }
        }));
        return;
      }

      setModalBusy(true);
      await clearCart();
      closeModal(true);
      continueFormSubmission(form, submitter);
    } catch (error) {
      closeModal(false);
      window.alert(error.message || 'Unable to update the cart.');
      document.dispatchEvent(new CustomEvent('cart:add-complete', {
        detail: { form: form, success: false }
      }));
    } finally {
      setModalBusy(false);
    }
  }

  function addVariant(variantId, trigger) {
    return getCart().then(async function (cart) {
      if (singleMatchingLine(cart, variantId) && cart.item_count === 1) {
        await refreshCartUi();
        return null;
      }

      if (cart.items && cart.items.length > 0) {
        var shouldReplace = await confirmReplacement(trigger);
        if (!shouldReplace) return null;
        setModalBusy(true);
        await clearCart();
        closeModal(true);
      }

      var added = await requestJson(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      await refreshCartUi();
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: added }));
      return added;
    }).catch(function (error) {
      closeModal(false);
      window.alert(error.message || 'Unable to update the cart.');
      return null;
    }).finally(function () {
      setModalBusy(false);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      forceFormQuantityToOne(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.oneItemPolicyBusy === 'true') return;
    form.dataset.oneItemPolicyBusy = 'true';
    Promise.resolve(handleFormSubmission(form, event.submitter)).finally(function () {
      delete form.dataset.oneItemPolicyBusy;
    });
  }, true);

  document.addEventListener('click', function (event) {
    var recommendationButton = event.target.closest('[data-drawer-recommend-add]');
    if (recommendationButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var variantId = recommendationButton.getAttribute('data-drawer-recommend-add');
      recommendationButton.disabled = true;
      addVariant(variantId, recommendationButton).finally(function () {
        recommendationButton.disabled = false;
      });
      return;
    }

    if (event.target.closest('[data-stepper-increment], .qty-plus')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-stepper-input], [data-cart-quantity-control] input, [data-product-quantity-control] input')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.target.value = '1';
  }, true);

  if (cancelButton) cancelButton.addEventListener('click', function () { closeModal(false); });
  if (closeButton) closeButton.addEventListener('click', function () { closeModal(false); });
  if (backdrop) backdrop.addEventListener('click', function () { closeModal(false); });
  if (confirmButton) confirmButton.addEventListener('click', function () { closeModal(true); });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false' && !confirmButton.disabled) {
      closeModal(false);
    }
  });

  document.addEventListener('cart:item-added', lockQuantityControls);
  document.addEventListener('shopify:section:load', lockQuantityControls);
  lockQuantityControls();

  window.EzsportOneItemCart = {
    enabled: true,
    addVariant: addVariant
  };
})();
